import { Locale } from '@ps-smart-cp/ppfw-client';
import { rawValueToEnum } from '../utils';

/** 任意項目の属性 */
enum OptionItemAttribute {
  mstCode = '1',
  date = '2',
  ym = '3',
  realNumber = '4',
  freeFormat = '5',
  halfWidth = '6',
  fullWidth = '7',
}

const nameConfig = {
  mstCode: new Map([[Locale.ja, 'コード']]),
  date: new Map([[Locale.ja, '年月日(YYYY/MM/DD)']]),
  ym: new Map([[Locale.ja, '年月(YYYY/MM)']]),
  realNumber: new Map([[Locale.ja, '実数(マイナスあり)']]),
  freeFormat: new Map([[Locale.ja, 'フリーフォーマット']]),
  halfWidth: new Map([[Locale.ja, '半角文字のみ']]),
  fullWidth: new Map([[Locale.ja, '全角文字のみ']]),
};

const toEnum = rawValueToEnum(OptionItemAttribute, OptionItemAttribute.freeFormat);

export const optionItemAttribute = {
  enum: OptionItemAttribute,
  nameConfig,
  toEnum,
};
export type { OptionItemAttribute };
